import { render, staticRenderFns } from "./Backend.vue?vue&type=template&id=2d7e50ac&"
import script from "./Backend.vue?vue&type=script&lang=ts&"
export * from "./Backend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports